module.exports = __webpack_public_path__ + "static/media/logo_sra.313df4d0.png";